/* eslint-disable import/prefer-default-export */
import Mola from '@api/mola'
import _get from 'lodash/get'
import types from '../constants'
import { getContentTypeName } from '@source/lib/globalUtil'

const resetPlaylist = () => dispatch => {
  dispatch({ type: types.GET_PLAYLIST_RESET })
}

const getPlaylist = id => (dispatch, getState) => {
  const store = getState(),
    platformId = _get(store, 'runtime.platformId', 7)

  dispatch({
    type: types.GET_PLAYLIST_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
      data: [],
    },
  })
  return Mola.getPlaylistPlaylists({ id, platformId }).then(result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_PLAYLIST_ERROR,
        payload: {
          meta: {
            status: 'error',
            error: result.meta.error || 'Error: get playlist failed',
          },
          data: [],
        },
      })
      return null
    } else {
      dispatch({
        type: types.GET_PLAYLIST_SUCCESS,
        payload: result,
      })
      return result
    }
  })
}

const getPlaylistChild = (playlist, index) => async (dispatch, getState) => {
  const store = getState(),
    platformId = _get(store, 'runtime.platformId', 7)
  const contentTypeName = getContentTypeName(_get(playlist, 'contentType', 'default'))
  if (contentTypeName === 'banner') {
    const bannerPosition = await Mola.getCampaignPosition(playlist.id)
    const positionName = _get(bannerPosition, 'data.positionName', '')
    const bannerResult = await Mola.getFeatureBanner({ id: positionName, platformId })
    const bannerPlaylist = {
      meta: {
        ...bannerResult.meta,
        id: playlist.id,
        title: playlist.title,
        contentType: playlist.contentType,
        sortOrder: index,
      },
      data: [...bannerResult.data],
    }
    dispatch({
      type: types.GET_PLAYLIST_CHILD,
      payload: bannerPlaylist,
    })
  } else {
    return Mola.getPlaylistChild({ id: playlist.id, platformId }).then(result => {
      const filterVisibility = result
        ? result.data.filter(dt => {
            return dt.visibility === 1
          })
        : []
      const results = {
        meta: {
          type: result ? result.meta.type : '',
          status: result ? result.meta.status : 'error',
          id: playlist.id,
          title: playlist.title,
          sortOrder: index,
          contentType: playlist.contentType,
          seasonNumber: playlist.seasonNumber ? playlist.seasonNumber : '',
        },
        data: filterVisibility,
      }
      dispatch({
        type: types.GET_PLAYLIST_CHILD,
        payload: results,
      })
    })
  }
}

// you can get only attributes you want depend on db column
// ex: id, tittle, short_title, description, visibility, content_type, cover_portrait, view_more_playlist_id
// if you want more than one attributes, just separeted by , ex: title,cover_landscape
const getSelectedAttributes = (id, attributes) => dispatch => {
  dispatch({
    type: types.GET_PLAYLIST_ATTRIBUTES_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
      data: [],
    },
  })

  return Mola.getSelectedAttributes(id, attributes).then(result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_PLAYLIST_ATTRIBUTES_ERROR,
        payload: result,
      })
    } else {
      dispatch({
        type: types.GET_PLAYLIST_ATTRIBUTES_SUCCESS,
        payload: result,
      })
    }
  })
}

const getPlaylistBanner = pathname => (dispatch, getState) => {
  const id = `landing-page-${pathname}`,
    filteredId = pathname

  const store = getState(),
    platformId = _get(store, 'runtime.platformId', 7)

  dispatch({
    type: types.GET_PLAYLIST_BANNER_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
      data: [],
    },
    id: filteredId,
  })
  return Mola.getFeatureBanner({ id, platformId }).then(result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_PLAYLIST_BANNER_ERROR,
        payload: {
          meta: {
            status: 'error',
            error: result.meta.error || 'Error: playlist banner failed',
          },
          data: [],
        },
        id: filteredId,
      })
    } else {
      dispatch({
        type: types.GET_PLAYLIST_BANNER_SUCCESS,
        payload: result,
        id: filteredId,
      })
    }

    return result
  })
}

export default {
  getPlaylist,
  resetPlaylist,
  getSelectedAttributes,
  getPlaylistChild,
  getPlaylistBanner,
}
